import { mainApi } from "../services/main/api";
import { StatusEnum } from "./getArtifacts";

const extendedApi = mainApi.injectEndpoints({
    endpoints: builder => ({
        updateAppeal: builder.mutation<UpdateAppealResponse, UpdateAppealRequest>({
            query: (request?: UpdateAppealRequest) => ({
                url: "updateAppeal",
                body: request,
                method: "POST",
            }),
            invalidatesTags: ["getAppealDetails"],
        }),
    }),
    overrideExisting: false,
});

export const { useUpdateAppealMutation } = extendedApi;

export interface UpdateAppealRequest {
    businessUseCase: string;
    appealArtifactId: string;
    appealDetails: any;
    appealStatus: StatusEnum;
    clientName: string;
}

export interface UpdateAppealResponse {
    status: string;
}
